import {
  GoogleOAuthURL,
  GithubOAuthURL,
  OidcOAuthURL,
  WechatOAuthURL,
  BussinessWechatOAuthURL,
  DingdingOAuthURL,
  CasAuthURL,
} from "./ApiConstants";

import GithubLogo from "assets/images/Github.svg";
import GoogleLogo from "assets/images/Google.png";
import SSOLogo from "assets/images/sso-key.png";
import CasLogo from "assets/images/cas.svg";
import Wechat from "assets/images/WeChat.svg";
import BusinessWeChat from "assets/images/BusinessWeChat.svg";
import Dingding from "assets/images/Dingding.svg";
export interface SocialLoginButtonProps {
  url?: string;
  name: string;
  logo?: string;
  label?: string;
}

export const GoogleSocialLoginButtonProps: SocialLoginButtonProps = {
  url: GoogleOAuthURL,
  name: "Google",
  logo: GoogleLogo,
};

export const GithubSocialLoginButtonProps: SocialLoginButtonProps = {
  url: GithubOAuthURL,
  name: "Github",
  logo: GithubLogo,
};

export const CasLoginButtonProps: SocialLoginButtonProps = {
  url: CasAuthURL,
  name: "Cas",
  logo: CasLogo,
};

export const OidcLoginButtonProps: SocialLoginButtonProps = {
  url: OidcOAuthURL,
  name: "OIDC SSO",
  logo: SSOLogo,
};
export const WechatSocialLoginButtonProps: SocialLoginButtonProps = {
  url: WechatOAuthURL,
  name: "wechat",
  logo: Wechat,
};

export const BussinessWechatSocialLoginButtonProps: SocialLoginButtonProps = {
  url: BussinessWechatOAuthURL,
  name: "wecom",
  logo: BusinessWeChat,
};

export const DingdingSocialLoginButtonProps: SocialLoginButtonProps = {
  url: DingdingOAuthURL,
  name: "dingtalk",
  logo: Dingding,
};

export const SocialLoginButtonPropsList: Record<
  string,
  SocialLoginButtonProps
> = {
  google: GoogleSocialLoginButtonProps,
  github: GithubSocialLoginButtonProps,
  oidc: OidcLoginButtonProps,
  cas: CasLoginButtonProps,
  wechat: WechatSocialLoginButtonProps,
  wecom: BussinessWechatSocialLoginButtonProps,
  dingtalk: DingdingSocialLoginButtonProps,
};

export type SocialLoginType = keyof typeof SocialLoginButtonPropsList;
